import { render, staticRenderFns } from "./TaxadeRebateDetails.vue?vue&type=template&id=5a56e568&scoped=true"
import script from "./TaxadeRebateDetails.vue?vue&type=script&lang=js"
export * from "./TaxadeRebateDetails.vue?vue&type=script&lang=js"
import style0 from "./TaxadeRebateDetails.vue?vue&type=style&index=0&id=5a56e568&prod&lang=css"
import style1 from "./TaxadeRebateDetails.vue?vue&type=style&index=1&id=5a56e568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a56e568",
  null
  
)

export default component.exports